import alwaysReady from "./assets/always-ready-footylogos.png";
import barcelonaSC from "./assets/barcelona-sc-guayaquil-footballlogos-org.png";
import bolivar from "./assets/bolivar-footylogos.png";
import bocaJuniors from "./assets/boca-juniors-footballlogos-org.png";
import cerroPorteno from "./assets/cerro-porteno-footballlogos-org.png";
import coquimboUnido from "./assets/coquimbo-unido-footballlogos-org.png";
import corinthians from "./assets/corinthians-footballlogos-org.png";
import cruzeiro from "./assets/cruzeiro-footballlogos-org.png";
import cusco from "./assets/cusco-footylogos.png";
import deportesTolima from "./assets/deportes-tolima-footballlogos-org.png";
import deportivoLaGuaira from "./assets/Deportivo-la-guaira-footylogos.png";
import estudiantes from "./assets/estudiantes-la-plata-footballlogos-org.png";
import flamengo from "./assets/flamengo-crf-footballlogos-org.png";
import fluminense from "./assets/fluminense-footballlogos-org.png";
import independienteDelValle from "./assets/independiente-del-valle-footballlogos-org.png";
import independienteMedellin from "./assets/independiente-medellin-footballlogos-org.png";
import independienteRivadavia from "./assets/independiente-rivadava-footballlogos-org.png";
import independienteSantaFe from "./assets/independiente-santa-fe-footballlogos-org.png";
import junior from "./assets/atletico-junior-footballlogos-org.png";
import lanus from "./assets/lanus-footballlogos-org.png";
import lduQuito from "./assets/ldu-quito-footballlogos-org.png";
import libertad from "./assets/club-libertad-footballlogos-org.png";
import mirassol from "./assets/mirassol-fc-footballlogos-org.png";
import nacional from "./assets/nacional-uruguay-footballlogos-org.png";
import palmeiras from "./assets/palmeiras-footballlogos-org.png";
import penarol from "./assets/penarol-footballlogos-org.png";
import platense from "./assets/atletico-platense-footballlogos-org.png";
import rosarioCentral from "./assets/rosario-central-footballlogos-org.png";
import sportingCristal from "./assets/sporting-cristal-footylogos.png";
import universidadCatolica from "./assets/universidad-catolica-footballlogos-org.png";
import universidadCentral from "./assets/universidad-central-footylogos.png";
import universitario from "./assets/universitario-peru-footylogos.png";

/** Nomes exatamente como em `grupos` em App.js */
export const escudosPorNome = {
  Flamengo: flamengo,
  Estudiantes: estudiantes,
  Cusco: cusco,
  "Independiente Medellín": independienteMedellin,
  Nacional: nacional,
  Universitario: universitario,
  "Coquimbo Unido": coquimboUnido,
  "Deportes Tolima": deportesTolima,
  Fluminense: fluminense,
  Bolívar: bolivar,
  "Deportivo La Guaira": deportivoLaGuaira,
  Rivadavia: independienteRivadavia,
  "Independiente Rivadavia": independienteRivadavia,
  "Boca Juniors": bocaJuniors,
  Cruzeiro: cruzeiro,
  "Universidad Católica": universidadCatolica,
  Barcelona: barcelonaSC,
  Peñarol: penarol,
  Corinthians: corinthians,
  "Santa Fé": independienteSantaFe,
  Platense: platense,
  Palmeiras: palmeiras,
  "Cerro Porteño": cerroPorteno,
  Junior: junior,
  "Sporting Cristal": sportingCristal,
  LDU: lduQuito,
  Lanús: lanus,
  "Always Ready": alwaysReady,
  Mirassol: mirassol,
  "Independiente del Valle": independienteDelValle,
  Libertad: libertad,
  "Rosario Central": rosarioCentral,
  "Universidad Central": universidadCentral,
};
